import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { Button, Drawer } from "@/ui-kit";
import { Form } from "@/components/controls";
import { FormProvider } from "react-hook-form";
import {
  LicenseForm,
  useLicenseForm,
} from "@/components/profile-forms/LicenseForm";
import type { IInspectorLicense } from "@/types/users-inspectors";

type IProps = {
  userId: number;
  license: IInspectorLicense;
  onSave: (v: IInspectorLicense) => void;
  onDismiss: () => void;
};

const EditModal = ({ userId, license, onSave, onDismiss }: IProps) => {
  const { t } = useTranslation();

  const handleSuccess = useCallback(
    (response: IInspectorLicense) => {
      onSave(response);
      onDismiss();
    },
    [onSave, onDismiss],
  );

  const { form, onSubmit, loading } = useLicenseForm({
    userId,
    license,
    onSuccess: handleSuccess,
  });

  return (
    <FormProvider {...form}>
      <Drawer
        className="settings__user-modal"
        title={t("label.license_details")}
        open={true}
        onOpenChange={onDismiss}
        closeOnOutsidePress={false}
        footer={
          <>
            <Button onClick={onDismiss} variant="ghost" color="layer1">
              {t("action.cancel")}
            </Button>
            <Button onClick={onSubmit} loading={loading}>
              {t("action.save")}
            </Button>
          </>
        }
      >
        <Form>
          <LicenseForm color="layer1" />
        </Form>
      </Drawer>
    </FormProvider>
  );
};

export default EditModal;
